import { __assign, __rest } from "tslib";
import * as React from 'react';
import { useTheme } from '../../../theme';
import cn from 'classnames';
import Switch from '@material-ui/core/Switch';
import { useComputedStyleProperty } from './../../hooks';
import { ToggleVariant } from '../types';
var Toggle = function (_a) {
    var _b;
    var className = _a.className, required = _a.required, _c = _a.variant, variant = _c === void 0 ? ToggleVariant.Normal : _c, restProps = __rest(_a, ["className", "required", "variant"]);
    var css = useTheme('BaseComponents').Toggle;
    var _d = useComputedStyleProperty('--variant', variant), toggleVariant = _d.value, elRef = _d.elRef;
    return (React.createElement(Switch, __assign({ className: cn(css.toggle, className, css[toggleVariant], (_b = {},
            _b[css.required] = required,
            _b)), classes: {
            checked: css.checked,
            disabled: css.disabled,
            thumb: css.thumb,
            track: css.track,
            switchBase: css.switchBase
        }, ref: elRef }, restProps)));
};
export default Toggle;
